export enum MetrikStatusModuleEnum {
  EQUIPMENT = 'Equipement',
  BUILDING = 'Bâtiment',
  RECEPTION = 'Réception',
}

export enum MetrikStatusTypeEnum {
  ACTIVE = 'Actif',
  INACTIVE = 'Inactif',
}
